import React from "react"
import { SelectField, MenuItem } from "material-ui"
import { ELanguage } from "../../models"
import { EnumValues } from "enum-values"
import _ from "lodash"
import strings from "../../localization/strings"
interface IProps {
    selectedLanguage: ELanguage
    readonly?: boolean
    hideLabel?: boolean
    label?: string
    error?: string
    existingLanguages?: ELanguage[]
    handleChange(selectedLanguage: ELanguage): void
}

const LanguageSelector: React.SFC<IProps> = (props: IProps) => {
    return (
        <SelectField
            data-intercom-target={"Application-Language-Selector"}
            floatingLabelText={props.label ? props.label : props.hideLabel ? null : strings.Application_Language}
            value={props.selectedLanguage}
            onChange={(event, key, payload) => props.handleChange(payload)}
            disabled={props.readonly ? true : false}
            errorText={props.error}
        >
            {EnumValues.getValues(ELanguage).filter(i => i !== ELanguage.Français).map(i =>
                <MenuItem
                    key={i}
                    value={i}
                    disabled={props.existingLanguages && props.existingLanguages.includes(i as ELanguage) ? true : false}
                    primaryText={EnumValues.getNameFromValue(ELanguage, i)}
                />
            )}
        </SelectField>
    )
}

export default LanguageSelector